import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import AlertCircleIcon from "@/shared/icons/AlertCircleIcon";
import GeneralInputWrapper from "../GeneralInputWrapper/GeneralInputWrapper";
import { FieldSettings, TextObject, WuiltContext } from "@/shared/types";
import type { FormViewProps } from "../../FormView";

interface TextAreaInputProps {
  registerProps: UseFormRegisterReturn;
  isError?: boolean;
  fieldSettings: FieldSettings;
  id: string;
  customClassNames?: FormViewProps["customClassNames"];
  text: TextObject;
  wuiltContext?: WuiltContext;
}

const TextAreaInput: React.FC<TextAreaInputProps> = ({
  registerProps,
  isError,
  fieldSettings,
  id,
  customClassNames,
  text,
  wuiltContext,
}) => {
  return (
    <GeneralInputWrapper
      isError={isError}
      customClassNames={customClassNames}
      wuiltContext={wuiltContext}
    >
      <textarea
        id={id}
        className={customClassNames?.textareaClass}
        placeholder={text[fieldSettings?.placeholder?.textId!]}
        minLength={fieldSettings?.minLength}
        maxLength={fieldSettings?.maxLength}
        {...registerProps}
        autoComplete={fieldSettings?.autoComplete}
      />
      {isError && <AlertCircleIcon />}
    </GeneralInputWrapper>
  );
};

export default TextAreaInput;
